module.exports = __webpack_public_path__ + "img/icomoon-app.8e1df80a.svg";